<script setup lang="ts">
import { mdiEye, mdiEyeOff } from "@mdi/js";
import { Button, FormField, Icon, InputGroup, TextInput, Tooltip } from "@soft-db/ui";
import { InputHTMLAttributes, InputTypeHTMLAttribute } from "vue";

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();
const props = defineProps<
	{
		icon?: string;
		label?: string;
		class?: any;
		inputClass?: any;
		errors?: string[];
	} & /* @vue-ignore */ InputHTMLAttributes
>();

const modelValue = defineModel<string>();

const { t } = useI18n();

const passwordVisible = ref(false);

const inputType = computed<InputTypeHTMLAttribute>(() =>
	passwordVisible.value ? "text" : "password"
);
</script>

<template>
	<FormField :class="props.class" :label="props.label" :errors="props.errors">
		<InputGroup :class="props.inputClass">
			<Icon v-if="props.icon" :d="props.icon" />
			<TextInput v-model="modelValue" :type="inputType" v-bind="attrs" />
			<Tooltip :tooltip="t(passwordVisible ? 'auth.hidePassword' : 'auth.revealPassword')">
				<Button variant="ghost" size="xs" @click="passwordVisible = !passwordVisible">
					<Icon :d="passwordVisible ? mdiEyeOff : mdiEye" />
				</Button>
			</Tooltip>
		</InputGroup>
	</FormField>
</template>
